var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaDebitColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 20,
    viewBox: "0 0 37 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005098",
    d: "M13.199 11.122L14.97.726h2.833l-1.772 10.396zM26.309.982a7.306 7.306 0 00-2.54-.437c-2.8 0-4.772 1.41-4.79 3.43-.015 1.495 1.409 2.328 2.484 2.826 1.103.509 1.474.834 1.469 1.289-.007.697-.881 1.015-1.696 1.015-1.134 0-1.736-.157-2.667-.545l-.365-.166-.398 2.328c.662.29 1.886.54 3.157.554 2.978 0 4.912-1.393 4.934-3.551.01-1.183-.744-2.083-2.38-2.825-.99-.481-1.596-.802-1.59-1.29 0-.431.514-.893 1.623-.893a5.228 5.228 0 012.12.398l.255.12.384-2.253m3.771 6.455c.235-.6 1.13-2.906 1.13-2.906-.017.027.233-.602.376-.992l.19.896s.544 2.48.657 3.002H30.08zM33.576.736h-2.19c-.678 0-1.185.185-1.483.862l-4.21 9.528h2.977s.486-1.281.597-1.563l3.629.005c.084.364.344 1.558.344 1.558h2.63L33.575.736zM10.822.733l-2.774 7.09-.296-1.44C7.236 4.72 5.627 2.922 3.828 2.02l2.536 9.092 2.998-.004L13.824.733h-3.002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.474.727H.905L.868.943c3.555.861 5.908 2.94 6.884 5.439l-.994-4.777C6.587.946 6.089.75 5.474.727",
    fill: "#F6A500"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Futura-BookOblique, Futura",
    fontSize: 8,
    fontStyle: "italic",
    fontWeight: 300,
    letterSpacing: -0.01,
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.803,
    y: 19.513
  }, "DEBIT")))));
}
export default SvgVisaDebitColor;